module.exports = __webpack_public_path__ + "img/datetime-es.f8f91f83.png";